/** budget 来源的类型 */
export const BudgetSourceType = {
  /** 点击文案中的 apply */
  apply: 1,
  /* 点击展开中的 apply */
  detailApply: 2,
  /** 手动填写 */
  manual: 3,
};
